<template>
  <div class="breadcrumbs-container">
    <el-breadcrumb :separator-icon="CustomSeparator">
      <el-breadcrumb-item to="/">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
        >
          <path
            d="M26.8134 13.7498C26.8134 13.5674 26.741 13.3926 26.612 13.2636C26.4831 13.1347 26.3082 13.0623 26.1259 13.0623C25.9436 13.0623 25.7687 13.1347 25.6398 13.2636C25.5108 13.3926 25.4384 13.5674 25.4384 13.7498H26.8134ZM7.56338 13.7498C7.56338 13.5674 7.49094 13.3926 7.36201 13.2636C7.23308 13.1347 7.05821 13.0623 6.87587 13.0623C6.69354 13.0623 6.51867 13.1347 6.38974 13.2636C6.26081 13.3926 6.18837 13.5674 6.18837 13.7498H7.56338ZM28.3892 16.9865C28.5183 17.1156 28.6933 17.1882 28.8759 17.1882C29.0585 17.1882 29.2336 17.1156 29.3627 16.9865C29.4918 16.8574 29.5643 16.6824 29.5643 16.4998C29.5643 16.3172 29.4918 16.1421 29.3627 16.013L28.3892 16.9865ZM16.5009 4.12477L16.9876 3.63801C16.9238 3.57399 16.8479 3.52319 16.7644 3.48853C16.6809 3.45388 16.5913 3.43604 16.5009 3.43604C16.4105 3.43604 16.3209 3.45388 16.2374 3.48853C16.1539 3.52319 16.078 3.57399 16.0141 3.63801L16.5009 4.12477ZM3.63912 16.013C3.51002 16.1421 3.4375 16.3172 3.4375 16.4998C3.4375 16.6824 3.51002 16.8574 3.63912 16.9865C3.76821 17.1156 3.9433 17.1882 4.12587 17.1882C4.30844 17.1882 4.48353 17.1156 4.61262 16.9865L3.63912 16.013ZM9.62588 29.5623H23.3759V28.1873H9.62588V29.5623ZM26.8134 26.1248V13.7498H25.4384V26.1248H26.8134ZM7.56338 26.1248V13.7498H6.18837V26.1248H7.56338ZM29.3627 16.013L16.9876 3.63801L16.0141 4.61152L28.3892 16.9865L29.3627 16.013ZM16.0141 3.63801L3.63912 16.013L4.61262 16.9865L16.9876 4.61152L16.0141 3.63801ZM23.3759 29.5623C24.2876 29.5623 25.1619 29.2001 25.8066 28.5555C26.4512 27.9108 26.8134 27.0365 26.8134 26.1248H25.4384C25.4384 26.6718 25.2211 27.1964 24.8343 27.5832C24.4475 27.97 23.9229 28.1873 23.3759 28.1873V29.5623ZM9.62588 28.1873C9.07887 28.1873 8.55426 27.97 8.16747 27.5832C7.78067 27.1964 7.56338 26.6718 7.56338 26.1248H6.18837C6.18837 27.0365 6.55054 27.9108 7.1952 28.5555C7.83985 29.2001 8.7142 29.5623 9.62588 29.5623V28.1873Z"
            fill="black"
            fill-opacity="0.6"
          />
        </svg>
      </el-breadcrumb-item>
      <el-breadcrumb-item
        v-if="product && product.category"
        :to="`/` + product.category"
        >{{ product.category }}</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="product && product.name">{{
        product.name
      }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div v-if="product" class="container">
    <div class="image-info-container">
      <img
        v-if="product && product.image"
        :src="product.image"
        :alt="product.name"
        class="img"
      />

      <el-collapse class="custom-collapse">
        <el-collapse-item title="About item" name="1">
          <div class="inner-content">
            This item is made from premium-quality materials, ensuring
            long-lasting durability and comfort. Designed with a modern yet
            timeless aesthetic, it's perfect for everyday use or special
            occasions.
          </div>
        </el-collapse-item>
        <el-collapse-item :title="shippingTitle" name="2">
          Your order will be carefully packed and shipped within 1–3 business
          days. Returns are accepted with no hassle — just contact us and we’ll
          guide you through the process.
        </el-collapse-item>
      </el-collapse>
    </div>

    <div class="info-container">
      <h1 class="product-title">{{ product.name }}</h1>
      <p class="product-info">
        Whether you wear it to express your resilience or as a reminder to seize
        the present moment, our "{{ product.name }}" is a symbol of empowerment
        and transformation.
      </p>
      <p class="product-price">Price: ${{ product.price }}</p>
      <div class="info-color">
        <p class="product-color-heading">Color:</p>
        <div class="product-color" :style="{ background: product.color }"></div>
      </div>
      <div class="info-size">
        <p class="product-color-heading">Size:</p>
        <p v-if="showError" class="error">Select the size!</p>
        <div class="size-container">
          <div class="cont">
            <input type="radio" name="size" value="S" v-model="selectedSize" />
            <label class="size"> S </label>
          </div>

          <div class="cont">
            <input type="radio" name="size" value="M" v-model="selectedSize" />
            <label class="size"> M </label>
          </div>

          <div class="cont">
            <input type="radio" name="size" value="L" v-model="selectedSize" />
            <label class="size"> L </label>
          </div>

          <div class="cont">
            <input type="radio" name="size" value="XL" v-model="selectedSize" />
            <label class="size"> XL </label>
          </div>

          <div class="cont">
            <input
              type="radio"
              name="size"
              value="XXL"
              v-model="selectedSize"
            />
            <label class="size"> XXL </label>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="add-to-cart" @click="addToBag">Add to bag</button>
        <button
          class="wishlist-btn"
          :class="{ active: isInWishlist }"
          @click="addToWishlist"
        >
          <svg
            class="heart-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="32"
            viewBox="0 0 36 32"
            fill="none"
          >
            <path
              d="M31.5535 18.1889L20.7109 29.0334C19.992 29.752 19.0172 30.1557 18.0007 30.1557C16.9842 30.1557 16.0094 29.752 15.2905 29.0334L4.44796 18.1908C3.55167 17.3023 2.8397 16.2455 2.35291 15.0812C1.86612 13.9168 1.61411 12.6677 1.61135 11.4057C1.60859 10.1437 1.85512 8.89353 2.33681 7.72704C2.81849 6.56054 3.52583 5.50068 4.41822 4.60829C5.31061 3.71589 6.37048 3.00855 7.53697 2.52687C8.70347 2.04519 9.95361 1.79865 11.2156 1.80141C12.4777 1.80418 13.7267 2.05619 14.8911 2.54297C16.0555 3.02976 17.1122 3.74174 18.0007 4.63803C19.8054 2.87828 22.2307 1.90039 24.7513 1.91618C27.2718 1.93197 29.6847 2.94018 31.4672 4.7224C33.2497 6.50463 34.2582 8.91735 34.2744 11.4379C34.2905 13.9585 33.3129 16.3839 31.5535 18.1889Z"
              stroke="currentColor"
              stroke-width="2.12517"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div
    class="pop-up"
    v-if="isOpen"
    data-aos="zoom-in"
    @mouseover="resetTimer"
    @mouseleave="startTimer"
  >
    <div class="top-pop-up">
      <div class="added-to-bag">
        <img src="/images/tick.svg" alt="tick" />
        <p class="added-text">Added to bag</p>
      </div>
      <p class="added-text">item in bag</p>
    </div>
    <div class="info-pop-up">
      <div class="image-container">
        <img
          v-if="product && product.image"
          :src="product.image"
          :alt="product.name"
          class="img-pop-up"
        />
      </div>
      <div class="text-info">
        <p v-if="product && product.name" class="heading-pop-up">
          {{ product.name }}
        </p>
        <p v-if="product && product.price" class="price-pop-up">
          {{ product.price }}$
        </p>
        <p v-if="product && product.color" class="color-pop-up">
          Color: {{ getColorName(product.color) }}
        </p>
        <p class="size-pop-up">Size: {{ selectedSize }}</p>
        <div class="buttons-pop-up">
          <minus-button
            :disabled="quantity === 1"
            @click="decrement()"
          ></minus-button>
          <span v-if="product && !product.quantity" class="amount">{{
            quantity
          }}</span>
          <plus-button @click="increment()"></plus-button>
        </div>
      </div>
    </div>
    <hr />
    <div class="price-info-pop-up">
      <div class="promocode">
        <p class="promocode-text">Promocode</p>
        <p class="promocode-text-value">-</p>
      </div>
      <div class="delivery">
        <p class="delivery-text">Delivery</p>
        <p class="delivery-text-value">20.00$</p>
      </div>
    </div>
    <hr />
    <div class="total-price">
      <p class="total-text">Total:</p>
      <p v-if="product && product.price" class="total-text-value">
        {{ product.price * quantity + 20 }}$
      </p>
    </div>
  </div>
</template>
  
<script>
import { mapGetters } from "vuex";
import MinusButton from "./base/MinusButton.vue";
import PlusButton from "./base/PlusButton.vue";
import namer from "color-namer";
import { h } from "vue";

export default {
  components: { MinusButton, PlusButton },
  props: {
    id: String,
  },
  data() {
    return {
      selectedSize: null,
      isLiked: false,
      quantity: 1,
      isOpen: false,
      timer: null,
      showError: false,
      shippingTitle: "More about shipping and returns",
      CustomSeparator: h("div", {
        style: `
        width: 50px;
        height: 1px;
        background: rgba(0, 0, 0, 0.60);
        `,
      }),
    };
  },

  methods: {
    setResponsiveTitle() {
      const width = window.innerWidth;
      if (width >= 240 && width <= 480) {
        this.shippingTitle = "Shipping & returns";
      } else {
        this.shippingTitle = "More about shipping and returns";
      }
    },

    addToBag() {
      this.$store.dispatch("checkLoggedIn");

      // Получаем информацию о продукте и выбранном размере
      const productInfo = {
        productId: this.product._id,
        productTitle: this.product.name,
        productImage: this.product.image,
        productPrice: this.product.price,
        productColor: this.product.color,
        productSize: this.selectedSize,
      };

      if (!productInfo.productSize) {
        this.showError = true;
        return;
      } else {
        this.showError = false;
      }

      const userData = this.$store.getters.userData;
      let userId = userData && userData.id ? userData.id : "guest";

      console.log("User ID:", userId);
      console.log("Product Info:", productInfo);
      console.log("size:", productInfo.productSize);

      // Диспатчим действие, передавая данные
      this.$store.dispatch("cart/addToCart", {
        userId,
        productId: productInfo.productId,
        size: productInfo.productSize, // Передаем размер
      });
      this.isOpen = true;
      this.startTimer();
    },

    addToWishlist() {
      this.$store.dispatch("checkLoggedIn");

      const productInfo = {
        productId: this.product._id,
        productTitle: this.product.name,
        productImage: this.product.image,
        productPrice: this.product.price,
        productColor: this.product.color,
      };

      const userData = this.$store.getters.userData;
      let userId = userData && userData.id ? userData.id : "guest";

      console.log("User ID:", userId);

      this.$store.dispatch("wishlist/addToWishlist", {
        userId,
        productId: productInfo.productId,
      });
      console.log(productInfo);
    },

    getColorName(hex) {
      if (!hex) return "unknown";
      return namer(hex).html[0].name;
    },

    // Устанавливаем таймер, который скрывает поп-ап через 5 секунд
    startTimer() {
      this.timer = setTimeout(() => {
        this.isOpen = false;
      }, 7000);
    },

    resetTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },

    async increment() {
      // if (!product || !product.productId || !product._id) return;
      // const productId = product.productId._id || product.productId.id;

      const productId = this.id;
      const userId = this.$store.getters.userData?.id || "guest";
      console.log("userId:", userId);
      console.log("productId:", productId);
      console.log("size", this.selectedSize);

      if (userId === "guest") {
        const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
        const productIndex = guestCart.findIndex(
          (item) =>
            item.productId === productId && item.size === this.selectedSize
        );
        if (productIndex !== -1) {
          guestCart[productIndex].quantity += 1;
        } else {
          guestCart.push({
            productId: productId,
            size: this.selectedSize,
            quantity: 1,
          });
        }

        localStorage.setItem("guestCart", JSON.stringify(guestCart));
        this.$store.dispatch("cart/fetchCart", userId);
      } else {
        await fetch(`${process.env.VUE_APP_URL}/cart`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: userId,
            productId: productId,
            size: this.selectedSize,
            operation: "increment",
          }),
        });
        await this.$store.dispatch("cart/fetchCart", userId);
      }
      this.quantity++;
    },

    async decrement() {
      // if (!product || !product.productId || !product._id) return;
      // const productId = product.productId._id || product.productId.id;

      const productId = this.id;
      const userId = this.$store.getters.userData?.id || "guest";
      console.log("userId:", userId);
      console.log("productId:", productId);
      console.log("size", this.selectedSize);

      if (userId === "guest") {
        const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
        const productIndex = guestCart.findIndex(
          (item) =>
            item.productId === productId && item.size === this.selectedSize
        );

        if (productIndex !== -1 && guestCart[productIndex].quantity > 1) {
          guestCart[productIndex].quantity -= 1;
        }

        localStorage.setItem("guestCart", JSON.stringify(guestCart));
        this.$store.dispatch("cart/fetchCart", userId);
      } else {
        await fetch(`${process.env.VUE_APP_URL}/cart`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: userId,
            productId: productId,
            size: this.selectedSize,
            operation: "decrement",
          }),
        });

        await this.$store.dispatch("cart/fetchCart", userId);
      }
      this.quantity--;
    },
  },

  computed: {
    ...mapGetters(["getAllProducts"]),
    ...mapGetters("wishlist", ["getWishlist"]),

    productQuantity() {
      return this.product && this.product.quantity ? this.product.quantity : 1;
    },

    product() {
      return this.getAllProducts.find(
        (product) => product._id === this.$route.params.id
      );
    },
  },
  mounted() {
    this.setResponsiveTitle();
    window.addEventListener("resize", this.setResponsiveTitle);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setResponsiveTitle);
  },
};
</script>

<style scoped>
.breadcrumbs-container {
  padding: 40px 40px 0px 40px;
}

::v-deep(.el-icon) {
  width: 5rem;
}

::v-deep(.breadcrumb__inner.is-link):hover {
  color: #000 !important;
}

.el-breadcrumb {
  display: flex;
  align-items: center;
}

::v-deep(.el-breadcrumb__inner) {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 500;
}

.custom-collapse {
  max-width: 63rem;
}

.custom-collapse ::v-deep(.el-collapse-item__header) {
  padding: 30px;
  color: #000;
  font-family: "Mabry Pro";
  font-size: clamp(1.3rem, 3vw, 2.4rem);
  font-weight: 500;
  border-radius: 8px 8px 0 0;
}

.custom-collapse ::v-deep(.el-collapse-item__content) {
  padding: 5px 30px 10px 30px;
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.custom-collapse ::v-deep(.el-collapse-item__wrap) {
  border-radius: 0 0 8px 8px;
}

.custom-collapse ::v-deep(.el-collapse-item:not(:last-child)) {
  margin-bottom: 15px;
}

.pop-up {
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #fff;
  width: 36rem;
  padding: 20px;
  position: absolute;
  top: 120px;
  right: 40px;
}

.top-pop-up {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.added-to-bag {
  display: flex;
  align-items: center;
  gap: 5px;
}

.added-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.1rem;
  font-weight: 300;
}

.info-pop-up {
  display: flex;
  justify-content: space-evenly;
  gap: 20px;
}

.text-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.heading-pop-up {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.5rem;
  font-weight: 500;
}

.price-pop-up,
.color-pop-up,
.size-pop-up {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.4rem;
  font-weight: 300;
}

.buttons-pop-up {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 8rem;
}

.promocode,
.delivery {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.promocode {
  margin-top: 12px;
}

.promocode-text,
.delivery-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.4rem;
  font-weight: 300;
}

.promocode-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.4rem;
  font-weight: 300;
}

.delivery-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.4rem;
  font-weight: 500;
}

.total-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 300;
}

.total-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 500;
}

.amount {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 500;
}

.total-price {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.img-pop-up {
  height: 16rem;
}

.container {
  padding: 40px;
  position: relative;
  display: flex;
  gap: 50px;
}

.img {
  height: 60rem;
  border-radius: 10px;
  margin-bottom: 30px;
}

.info-container {
  padding-top: 20px;
  gap: 20px;

  display: flex;
  flex-direction: column;
}

.product-title {
  color: #000;
  font-family: "Mabry Pro";
  font-size: clamp(2rem, 3vw, 3.6rem);
  font-weight: 500;
}

.product-info {
  color: #000;
  font-family: "Mabry Pro";
  font-size: clamp(1.4rem, 3vw, 2.4rem);
  font-weight: 300;
  max-width: 55rem;
}

.product-price {
  color: #000;
  font-family: "Mabry Pro";
  font-size: clamp(2rem, 3vw, 3rem);
  font-weight: 500;
}

.product-color-heading {
  color: #5b5b5b;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.product-color {
  width: 30px;
  height: 30px;
}

.info-color {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-size {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.size-container {
  display: flex;
  gap: 16px;
  margin-bottom: 25px;
}

.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 30rem;
}

.add-to-cart {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 500;
  border-radius: 4.073px;
  background: #000;
  padding: 8px 18px;
  text-align: center;
}

.size {
  padding: 10px;
  border: 0.5px solid #000;
  display: flex;
  justify-content: center;
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.4rem;
  font-weight: 300;
  min-width: 4.5rem;
}

.cont {
  position: relative;
  cursor: pointer;
}

.size:hover {
  background: #000;
  color: #fff;
}

input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  /* opacity: 0; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 100%;
  height: 100%;
}

input[type="radio"]:checked + .size {
  background-color: #000;
  color: #fff;
}

/* Наведение */
.wishlist-btn:hover .heart-icon {
  fill: #d3011c;
}

/* Клик или выбранное состояние */
.wishlist-btn.active .heart-icon {
  fill: #d3011c;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 10px;
  }
  .image-info-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .size {
    font-size: 1.6rem;
  }
  .img {
    height: 25rem;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .img {
    height: 40rem;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  .container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .img {
    height: 50rem;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
  .img {
    height: 50rem;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1900px) {
}
</style>
  